import * as moment from 'moment';
import { Component, HostBinding } from '@angular/core';
import { ThemingService, HeaderModule, SidebarModule, LinkModule, LogoModule, NavbarModule, MainContentModule, FooterModule, AlertModule } from '@michelin/theme';

import { environment } from '../../environments/environment';
import { RouterLink, RouterOutlet } from '@angular/router';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';


const darkClassName = 'dark-mode';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [HeaderModule, SidebarModule, LinkModule, RouterLink, LogoModule, NavbarModule, MatIconButton, MatIcon, MainContentModule, RouterOutlet, FooterModule, AlertModule]

})
export class LayoutComponent {
  @HostBinding('class') private className = this.themingService.theme.className;

  year = moment.utc().format('YYYY');
  version = environment.version;
  title = 'PAT - Pedido de Assistência Técnica';
  darkMode = this.className === darkClassName;

  constructor(
    private readonly themingService: ThemingService
  ) {}

  /**
   * Toggle theme
   * Light or dark
   */
  setTheme() {
    this.darkMode = !this.darkMode;
    this.className = this.themingService.display(this.darkMode ? darkClassName : '', this.darkMode);
  }
}
